import { type Account } from '@qdrant/qdrant-cloud-public-api/account/v1';
import { type User } from '@qdrant/qdrant-cloud-public-api/iam/v1';
import { memoize } from 'micro-memoize';

export const isAccountOwner = (account: Account, userEmail: string) =>
  account.ownerEmail.toLowerCase() === userEmail.toLowerCase();

export const sortAccountByNameAndOwnerFirst = (a: Account, b: Account, userEmail: string) => {
  const aIsOwner = isAccountOwner(a, userEmail);
  const bIsOwner = isAccountOwner(b, userEmail);

  if (aIsOwner && !bIsOwner) {
    return -1;
  }

  if (!aIsOwner && bIsOwner) {
    return 1;
  }

  return a.name.localeCompare(b.name);
};

export const getAccountsWithOwnership = memoize((accounts: Account[], user: User) =>
  accounts.filter((account) => isAccountOwner(account, user.email)),
);

export const getInvitedAccounts = memoize((accounts: Account[], user: User) =>
  accounts.filter((account) => !isAccountOwner(account, user.email)),
);

export const getAccountMembers = memoize((account: Account, users: User[]) =>
  users.filter((user) => !isAccountOwner(account, user.email)),
);
